export function iter(start: number = 0, end: number = Infinity, step: number = 1): Iterator<number> {
    let nextIndex = start;
    let iterationCount = 0;

    const rangeIterator = {
        next() {
            let result;
            if (nextIndex < end) {
                result = { value: nextIndex, done: false };
                nextIndex += step;
                iterationCount++;
                return result;
            }
            return { value: iterationCount, done: true };
        },
    };
    return rangeIterator;
}

export function* iter_map(iterator: Iterator<number>, fn: Function) {
    var n = iterator.next();
    while (!n.done) {
        yield fn(n.value);
        n = iterator.next();
    }
}
